import { ProgressBar, Tooltip } from '@percent/lemonade'
import styled from 'styled-components'
import type { FundraiserProgressProps } from './fundraiser-progress.types'
import { formatMoney, formatMoneyShort } from '@percent/utility'

const StyledProgress = styled.div`
  position: relative;
  word-break: break-word;
  width: 100%;
`

export const FundraiserProgress = ({
  locale,
  donated,
  goal,
  enableAnimation = true,
}: FundraiserProgressProps) => (
  <StyledProgress data-testid="fundraiser-progress">
    <Tooltip
      content={
        `${((donated.amount / goal.amount) * 100).toFixed(0)}% ` +
        `${formatMoney(donated, { locale })}/${formatMoney(goal, {
          locale,
        })}`
      }
    >
      {formatMoneyShort(donated, { locale })}/
      {formatMoneyShort(goal, { locale })}
    </Tooltip>
    <ProgressBar
      progressPercentage={Math.min((donated.amount / goal.amount) * 100, 100)}
      backgroundColorComplete={
        donated.amount >= goal.amount ? 'success400' : 'primary400'
      }
      backgroundColorIncomplete={
        donated.amount >= goal.amount ? 'success400' : 'primary400'
      }
      shadeColor="gray90"
      sizeVariant="x-small"
      enableAnimation={enableAnimation}
    />
  </StyledProgress>
)
